import React from 'react'
import { VEC_ICON_NAME } from "../../icons/constants";
import styles from "./CardWTopLeftIcon.styles"
import Icons from '../../icons/Icons';
import Heading from '../../heading/Heading';
import { HEADING } from '../../heading/constants/constants';
import BasicCard from '../basiccard/BasicCard';
import Button from '../../button/Button';

const CardWTopLeftIcon = ({
    title,
    subText,
    linkButtonProps = { label: "", onClickCb: () => { } },
    topLeftIcon = { icon: "", title: "" },
}) => {
    return (
        <BasicCard customStyles={styles.container}>
            {topLeftIcon.icon &&
                <div style={styles.topLeftIcon} title={topLeftIcon.title}>
                    <Icons familyName={"vec"} iconName={topLeftIcon.icon || VEC_ICON_NAME.INFO_ICON} />
                </div>
            }
            <div style={styles.cardTitleContainer}>
                {title && (
                    <Heading type={HEADING.H3} customStyle={styles.heading}>
                        {title}
                    </Heading>
                )}
                {subText && (
                    <p style={styles.paragraph}>{subText}</p>
                )}
            </div>
            <div style={styles.cardButtonContainer}>
                {linkButtonProps.label && (
                    <Button style={{ ...styles.cardButton }} onClickCb={linkButtonProps.onClickCb}>{linkButtonProps.label}</Button>
                )}
            </div>
        </BasicCard>
    )
}

export default CardWTopLeftIcon